import { createContext, useMemo, useState } from "react";

type ViewType = "default" | "editor" | "pdf" | "thumbnail";

type ViewProviderType = {
  view: ViewType;
};

const ViewProviderState: ViewProviderType = {
  view: "default",
};

export const ViewContext = createContext<ViewProviderType>(ViewProviderState);

type ViewProviderProps = {
  children: React.ReactNode;
  value?: { view?: ViewType };
};

export const ViewProvider = ({ children, value }: ViewProviderProps) => {
  const [view] = useState<ViewType>(value?.view || "default");
  // One object for the provider's life: a new one each render re-rendered
  // every element of every slide whenever a parent did (opening the Story
  // Agent re-renders the editor shell).
  const context = useMemo(() => ({ view }), [view]);

  return <ViewContext.Provider value={context}>{children}</ViewContext.Provider>;
};
